// src/components/services/ServicesPricingSection.jsx
import React from "react";
import { Target, Hand, RotateCcw, Wrench } from "lucide-react";

const ServicesPricingSection = () => {
  const isMobile = window.innerWidth <= 768;

  const servicesSectionStyle = {
    backgroundColor: "#f5f5f5",
    padding: "4rem 0",
  };

  const containerStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 1.5rem",
  };

  const categoryStyle = {
    backgroundColor: "white",
    padding: "2rem",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
    marginBottom: "2rem",
    borderLeft: "4px solid #0891b2",
  };

  const serviceItemStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: isMobile ? "flex-start" : "center",
    padding: "1rem 0",
    borderBottom: "1px solid #e0e0e0",
    flexDirection: isMobile ? "column" : "row",
    gap: isMobile ? "0.5rem" : "0",
  };

  const priceStyle = {
    color: "#0891b2",
    fontWeight: "bold",
    fontSize: "1.1rem",
  };

  const drillingServices = [
    { name: "Conventional (3 holes, no finger grips, no slug)", price: "$50" },
    { name: "Traditional Finger Tip Drilling (Grips Included)", price: "$60" },
    { name: "2 Fingers only (Grips included)", price: "$40" },
    { name: "Add-on: Urethane Thumb Slug", price: "$15", isAddon: true },
    { name: "Add-on: Vise IT Locking base", price: "$25", isAddon: true },
    { name: "Add-on: Turbo/JoPo Locking Outer", price: "$30", isAddon: true },
  ];

  const fingerServices = [
    { name: "Finger Insert/grip, installed", price: "$7.5 Each" },
    { name: "Finger Insert/grip uninstalled", price: "$5 Each" },
    { name: "Vise Interchangeable Thumb Insert (Inner)", price: "$30" },
    { name: "JoPo Interchangeable Thumb Insert (Inner)", price: "$45" },
    { name: "Turbo Interchangeable Thumb Insert (Inner)", price: "$45" },
  ];

  const plugServices = [
    { name: "Full plug & redrill with new Finger Inserts", price: "$70" },
    { name: "Plug & redrill fingers with new Finger Inserts", price: "$50" },
    { name: "Plug thumb hole/weight hole and refinish", price: "$15" },
    {
      name: "Plug & redrill thumb only (Thumb attachments extra)",
      price: "$30",
    },
  ];

  const repairServices = [
    { name: "Resurface - Light Sanding or Polishing", price: "$15" },
    {
      name: "Full Service (Rejuvenate and resurface to customer's choice)",
      price: "$30",
    },
  ];

  return (
    <section style={servicesSectionStyle}>
      <div style={containerStyle}>
        <h2
          style={{
            fontSize: "2.5rem",
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: "3rem",
            color: "#333",
          }}
        >
          Our Services & Pricing
        </h2>

        {/* Drilling Services */}
        <div style={categoryStyle}>
          <h3
            style={{
              fontSize: "1.8rem",
              fontWeight: "bold",
              marginBottom: "1.5rem",
              color: "#333",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Target
              size={24}
              color="#0891b2"
              style={{ marginRight: "0.5rem" }}
            />
            Drilling Outside Ball
          </h3>
          {drillingServices.map((service, index) => (
            <div
              key={index}
              style={{
                ...serviceItemStyle,
                ...(index === drillingServices.length - 1
                  ? { borderBottom: "none" }
                  : {}),
                ...(service.isAddon
                  ? { backgroundColor: "#f8f9fa", paddingLeft: "1.5rem" }
                  : {}),
              }}
            >
              <span style={{ fontSize: "1rem", color: "#333" }}>
                {service.name}
              </span>
              <span style={priceStyle}>{service.price}</span>
            </div>
          ))}
        </div>

        {/* Finger Inserts */}
        <div style={categoryStyle}>
          <h3
            style={{
              fontSize: "1.8rem",
              fontWeight: "bold",
              marginBottom: "1.5rem",
              color: "#333",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Hand size={24} color="#0891b2" style={{ marginRight: "0.5rem" }} />
            Finger Inserts & Interchangeable Thumbs
          </h3>
          {fingerServices.map((service, index) => (
            <div
              key={index}
              style={
                index === fingerServices.length - 1
                  ? { ...serviceItemStyle, borderBottom: "none" }
                  : serviceItemStyle
              }
            >
              <span style={{ fontSize: "1rem", color: "#333" }}>
                {service.name}
              </span>
              <span style={priceStyle}>{service.price}</span>
            </div>
          ))}
        </div>

        {/* Plug and Redrill */}
        <div style={categoryStyle}>
          <h3
            style={{
              fontSize: "1.8rem",
              fontWeight: "bold",
              marginBottom: "1.5rem",
              color: "#333",
              display: "flex",
              alignItems: "center",
            }}
          >
            <RotateCcw
              size={24}
              color="#0891b2"
              style={{ marginRight: "0.5rem" }}
            />
            Plug and Redrill
          </h3>
          {plugServices.map((service, index) => (
            <div
              key={index}
              style={
                index === plugServices.length - 1
                  ? { ...serviceItemStyle, borderBottom: "none" }
                  : serviceItemStyle
              }
            >
              <span style={{ fontSize: "1rem", color: "#333" }}>
                {service.name}
              </span>
              <span style={priceStyle}>{service.price}</span>
            </div>
          ))}
        </div>

        {/* Repairs & Surface Changes */}
        <div style={categoryStyle}>
          <h3
            style={{
              fontSize: "1.8rem",
              fontWeight: "bold",
              marginBottom: "1.5rem",
              color: "#333",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Wrench
              size={24}
              color="#0891b2"
              style={{ marginRight: "0.5rem" }}
            />
            Repairs & Surface Changes
          </h3>
          {repairServices.map((service, index) => (
            <div
              key={index}
              style={
                index === repairServices.length - 1
                  ? { ...serviceItemStyle, borderBottom: "none" }
                  : serviceItemStyle
              }
            >
              <span style={{ fontSize: "1rem", color: "#333" }}>
                {service.name}
              </span>
              <span style={priceStyle}>{service.price}</span>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div
          style={{
            backgroundColor: "#333",
            color: "white",
            padding: "2rem",
            borderRadius: "12px",
            textAlign: "center",
            marginTop: "2rem",
          }}
        >
          <h3
            style={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              marginBottom: "1rem",
            }}
          >
            Professional Equipment & Expert Service
          </h3>
          <p style={{ fontSize: "1rem", color: "#e0e0e0", marginBottom: "0" }}>
            All services performed using state-of-the-art equipment by
            experienced professionals. We guarantee precision drilling and
            quality workmanship on every job.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServicesPricingSection;
